import { Button, CircularProgress, Grid, Typography, useTheme } from '@mui/material';
import { UserInvitation } from 'vendor-marketplace-shared-library';
import React from 'react';

type AcceptInvitationFormProps = {
  onAccept: () => void;
  onDecline: () => void;
  loading: boolean;
  invitation?: UserInvitation;
};
export default function AcceptInvitationForm(props: AcceptInvitationFormProps) {
  const theme = useTheme();
  return (
    <Grid container sx={styles.mainContainer}>
      <Grid item>
        <Typography>
          {!props.invitation?.invitedByUser
            ? 'You have been invited to join'
            : `${props.invitation.invitedByUser.firstName} has invited you to join`}
        </Typography>
      </Grid>
      <Grid item>
        <Typography>{props.invitation?.organizationAccount!.name}</Typography>
      </Grid>
      {props.loading ? (
        <CircularProgress size={20} sx={{ color: theme.palette.primary.main }} />
      ) : (
        <Grid item>
          <Grid container sx={styles.mainContainer}>
            <Grid item>
              <Button variant='contained' onClick={props.onAccept}>
                Accept Invitation
              </Button>
            </Grid>
            <Grid item sx={{ width: '100%' }}>
              <Button sx={{ width: '100%' }} variant='text' onClick={props.onDecline}>
                Decline
              </Button>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}

const styles = {
  mainContainer: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: 2,
  },
};
